import { Navigate, useLocation } from "react-router-dom";
import { ROUTE_MAP } from "../constants/routes";
import { getRouteLang } from "../utils/language";

/**
 * Catch-all route component.
 *
 * Sprawdza czy aktualny URL pasuje do ścieżki w "innym" języku.
 * Jeśli tak — przekierowuje na wersję w aktualnym języku (z zachowaniem parametrów i query).
 * Jeśli nie — przekierowuje na "/".
 */
const LocalizedRedirect = () => {
    const location = useLocation();
    const lang = getRouteLang();
    const otherLang = lang === "pl" ? "en" : "pl";

    for (const [, paths] of Object.entries(ROUTE_MAP)) {
        const otherPath = paths[otherLang];
        const currentPath = paths[lang];

        if (!otherPath || !currentPath || otherPath === currentPath) continue;

        // Statyczne ścieżki
        if (!otherPath.includes(":")) {
            if (location.pathname === otherPath) {
                return <Navigate to={currentPath + location.search + location.hash} replace />;
            }
            continue;
        }

        // Dynamiczne ścieżki — regex match
        const regex = new RegExp(
            "^" + otherPath.replace(/:[^/]+/g, "([^/]+)") + "$"
        );
        const match = location.pathname.match(regex);
        if (match) {
            const paramPlaceholders = [...otherPath.matchAll(/:([^/]+)/g)].map(m => m[1]);
            let targetPath = currentPath;
            paramPlaceholders.forEach((param, i) => {
                targetPath = targetPath.replace(`:${param}`, match[i + 1]);
            });
            return <Navigate to={targetPath + location.search + location.hash} replace />;
        }
    }

    // Nie znaleziono dopasowania — na stronę główną
    return <Navigate to="/" replace />;
};

export default LocalizedRedirect;
